module.exports = __webpack_public_path__ + "static/media/visa.6222b42b.svg";